"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _validate = _interopRequireDefault(require("validate.js"));
var _validations = _interopRequireDefault(require("./validations"));
var Dates = _interopRequireWildcard(require("../dates"));
var _creditCards = require("../creditCards");
var _i18n = _interopRequireDefault(require("../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * Validate the name field.
 * @param {string} name - The name to validate.
 * @returns {string|null} - Validation error message or null if valid.
 * @private
 */
function _validateName(name) {
  return name.split(' ').length < 2 ? _i18n["default"].t(_tokens["default"].labels.validations.firstAndLastName) : null;
}

/**
 * Validate input based on the field name and value.
 * @param {string} fieldName - The name of the field to validate.
 * @param {*} value - The value of the field.
 * @returns {string|null} - Validation error message or null if valid.
 */
var validateInput = function validateInput(fieldName, value) {
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "en";
  // Handle special cases based on field name
  if (fieldName.toLowerCase().includes('effdate')) {
    return Dates.validateDate(value, false, false, true, locale);
  }
  if (fieldName.toLowerCase() === 'effectivedate') {
    return Dates.validateDate(value, false, false, false, locale);
  }
  if (fieldName.toLowerCase() === 'hiredate') {
    return Dates.validateDate(value, false, false, false, locale);
  }
  if (fieldName.toLowerCase().includes('date')) {
    return Dates.validateDate(value, true, false, false, locale);
  }
  if (fieldName.toLowerCase().includes('credit')) {
    return (0, _creditCards.validateCreditCard)(value);
  }
  if (fieldName.toLowerCase() === 'name') {
    return _validateName(value);
  }

  // General validation using validate.js
  var formValues = (0, _defineProperty2["default"])({}, fieldName, value.toString());
  var formFields = (0, _defineProperty2["default"])({}, fieldName, _validations["default"][fieldName]);
  var result = (0, _validate["default"])(formValues, formFields);
  return result ? result[fieldName][0] : null;
};
var _default = exports["default"] = validateInput;